import React from 'react';


export default function MainCard({ children, colorborder = false}) {
    return (
        <div 
        className={`bg-white p-3 mt-3 rounded shadow ${colorborder ? "border border-2 border-success": ""}`}
        >
            {children}
        </div>
    )
}